export const SET_O3_REQUEST = 'SET_O3_REQUEST';
export const SET_O3_FAILED = 'SET_O3_FAILED';
export const SET_O3_PRIORITIES_SUCCESS = 'SET_O3_PRIORITIES_SUCCESS';
export const SET_O3_STAKEHOLDERS_LIST_SUCCESS = 'SET_O3_STAKEHOLDERS_LIST_SUCCESS';
export const CLEAN_O3 = 'CLEAN_O3';
